<template>
    <MainContent title="Gestión de butacas">
        <template v-slot:content>
            <div class="row">
                <div class="col-12" v-if="select_region">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">Seleccionar la región:</h3>
                        </div>
                        
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 text-center">
                                    <div class="form-group">
                                        <Button @click="openModal">Cargar butacas bloqueadas de evento anterior</Button>
                                        <CargarButacasEventoAnterior @close="closeModal" @cerrarbutacas="bloquearAsientosOldEvent"></CargarButacasEventoAnterior>
                                        <router-link 
                                            :to="{
                                                name: 'back.events.sesion.listado-bloqueos',
                                                params: { evento_id: evento_id, sesion_id: sesion_id },
                                            }" 
                                            class="btn btn-secondary ml-2"
                                        >
                                            <i class="fas fa-lock"></i> Listado bloqueos
                                        </router-link>
                                        <a v-if="evento?.place_obj?.url_svg_asientos" :href="url_imprimir_plano_general" class="btn btn-secondary ml-2" target="_blank">
                                            <i class="fas fa-map"></i> Imprimir plano general
                                        </a>
                                    </div>
                                </div>
                                <div class="col-12" v-if="!loading && evento">
                                    <b-tabs pills card align="center">
                                        <b-tab title="Svg" active>
                                            <template v-if="evento?.place_obj?.tipo_svg === 1 && evento?.place_obj?.tipo_proceso_online === 1">
                                                <ContentOrLoading>
                                                    <SvgComponent 
                                                        v-if="zonas.length > 0 "
                                                        :zonas="zonas" 
                                                        :place="evento.place_obj" 
                                                        :sesion_id="sesion_id"
                                                        @clickZona="irAZona"
                                                    />
                                                </ContentOrLoading>
                                            </template>
                                            <template v-if="evento?.place_obj?.tipo_svg === 1 && evento?.place_obj?.tipo_proceso_online === 2">
                                                <SeccionesComponent
                                                    :event="evento"
                                                    :sesion_id="parseInt(sesion_id)"
                                                    @terminar="irAZona"
                                                />
                                            </template>
                                            <template v-if="evento?.place_obj?.tipo_svg === 2 && evento?.place_obj?.tipo_proceso_online === 3">
                                                <div class="col-12">
                                                    <ButacasAnexoComponent
                                                        :recinto_id="evento.place_id"
                                                        :evento_id="evento_id"
                                                        :sesion_id="sesion_id"
                                                        :plazas="plazas"
                                                        @clickPlaza="clickPlaza" 
                                                    />
                                                    <div class="col-12 text-center" style="height: 150px" v-if="loading">
                                                        <LoaderComponent></LoaderComponent>
                                                    </div>
                                                </div>
                                                <leyenda-color-eventos />
                                                <div>
                                                    <Button class="m-3" @click.prevent="selectAllButacas">{{ plazas ? 'Seleccionar/Limpiar todas' : 'Seleccionar todas'}}</Button>
                                                    <Button class="m-3" @click.prevent="clearAllButacas" v-if="!plazas">Limpiar todas</Button>
                                                </div>
                                                <div class="col-12" v-if="!loading">   
                                                    <div class="form-group">
                                                        <label>AFORO: {{ contadorPlazas.aforo }}</label>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>BLOQUEADO: {{ contadorPlazas.bloqueado }}</label>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>LIBRES: {{ contadorPlazas.libres }}</label>
                                                    </div>
                                                </div>

                                                <div class="col-12" v-if="!loading">
                                                    <FormInput label="Concepto" v-model="concepto" />
                                                </div>
                                                <div class="col-12" v-if="!loading">
                                                    <Button class="btn-lg btn-block" type="button" name="button" @click="bloquearAsientosGeneral" :disabled="bloquear_boton || bloqueando">Bloquear / Liberar</Button>
                                                    <div class="col-12 text-center" v-if="bloqueando" style="height: 150px">
                                                        <LoaderComponent></LoaderComponent>
                                                    </div>
                                                </div>
                                            </template>
                                        </b-tab>
                                        <b-tab title="Listado">
                                            <TablaSectoresComponent
                                                :zonas="zonas"
                                                @goTo="selectZonaTable"
                                            />
                                        </b-tab>
                                    </b-tabs>                          
                                </div>
                                <div class="col-12 text-center" style="height: 150px" v-else>
                                    <LoaderComponent></LoaderComponent>
                                </div>
                                <div  v-if="zonas.length > 0" class="col-12 text-center">
                                    <h3>
                                        <b>AFORO: </b>
                                        {{ total_aforo }}
                                    </h3>
                                    <h3>
                                        <b>BLOQUEADO: </b>
                                        {{ total_bloqueadas }}
                                    </h3>
                                    <h3>
                                        <b>OCUPADOS: </b>
                                        {{ total_confirmados }}
                                    </h3>
                                    <h3>
                                        <b>BUTACAS EN PROCESO DE COMPRA: </b>
                                        {{ total_sesion }}
                                    </h3>
                                    <h3>
                                        <b>LIBRES: </b>
                                        {{ total_libres }}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12" v-if="select_butacas">
                    <div class="card">
                        <div class="card-header">
                            <h2 class="card-title">Region: {{ zona.name }}</h2>
                            <br><br>
                            <div class="d-flex justify-content-between">
                                <h3 class="card-title">Seleccionar butacas:</h3>
                                <Button type="button" name="button" @click="volver">Cambiar región</Button>
                            </div>
                        </div>
                        
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12" v-if="zona">
                                    <TerrenoJuegoComponent v-if="!zona.tiene_plazas" :direccion_campo="zona.direccion_campo ? zona.direccion_campo : 0" :tipo_recinto="zona.tipo_recinto"/>

                                    <div class="container-butacas-wrapper" v-if="!loading && zona.with_seats">
                                        <div v-if="!zona.tiene_plazas" :class="'container-butacas text-align-' + zona.print_align">
                                            <template v-for="(butacas, fila) in filas">
                                                <span :key="fila">
                                                    <span class="fila">{{ fila }}</span>
                                                    <template v-for="(asiento, index) in butacas">
                                                        <AsientoComponent :asiento="asiento" :fila="fila" :key="index+'_2'" @toggle="() => toggleSeleccion(fila, asiento.asiento, true, true)"/>
                                                    </template>

                                                    <br />
                                                </span>
                                            </template>
                                        </div>
                                        <div v-else>
                                            <RecintoAnexoComponent 
                                                :key="recintoAnexoKey"
                                                :region_id="zona.id" 
                                                :plazas="zona.plazas"
                                                :tipo_svg="zona.tipo_svg"
                                                :evento_id="evento_id"
                                                :sesion_id="sesion_id"
                                                :recinto_id="evento.place_id"
                                                @clickZona="clickZona" 
                                            />
                                        </div>
                                    </div>
                                    <div v-if="!zona.with_seats">
                                        <FormInput label="Nº de butacas a bloquear" type="number" v-model="n_butacas" />
                                    </div>
                                    <div class="col-12 text-center" style="height: 150px" v-if="loading">
                                        <LoaderComponent></LoaderComponent>
                                    </div>
                                </div>
                                <leyenda-color-eventos />
                                <div>
                                    <Button class="m-3" @click.prevent="selectAll">{{ zona.tiene_plazas ? 'Seleccionar/Limpiar todas' : 'Seleccionar todas'}}</Button>
                                    <Button class="m-3" @click.prevent="clearAll" v-if="!zona.tiene_plazas">Limpiar todas</Button>
                                </div>
                                <div class="col-12" v-if="!loading">   
                                    <div class="form-group">
                                        <label>AFORO: {{ zona.aforo ? zona.aforo : zona.total_asientos }}</label>
                                    </div>
                                    <div class="form-group">
                                        <label>BLOQUEADO: {{ zona.count_bloqueados }}</label>
                                    </div>
                                    <div class="form-group">
                                        <label>LIBRES: {{ zona.total_libres }}</label>
                                    </div>
                                </div>

                                <div class="col-12" v-if="!loading">
                                    <FormInput label="Concepto" v-model="concepto" />
                                </div>
                                <div class="col-12" v-if="!loading">
                                    <Button class="btn-lg btn-block" type="button" name="button" @click="bloquearAsientos" :disabled="bloquear_boton || bloqueando">Bloquear / Liberar</Button>
                                    <div class="col-12 text-center" v-if="bloqueando" style="height: 150px">
                                        <LoaderComponent></LoaderComponent>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </MainContent>
</template>

<script>
import LoaderComponent from '@/components/preloader/LoaderComponent';
import SvgComponent from '@/components/svg/SvgComponent';
import AsientoComponent from "@/components/backend/stepper/components/AsientoComponent";
import TerrenoJuegoComponent from '@/components/common/Asientos/TerrenoJuegoComponent.vue';
import MainContent from '@/components/backend/components/MainContent.vue';
import TablaSectoresComponent from '@/components/backend/stepper/components/TablaSectoresComponent.vue';
import CargarButacasEventoAnterior from '@/components/backend/eventos/sesiones/bloquear-asientos/modals/CargarButacasEventoAnterior.vue';
import RecintoAnexoComponent from './RecintoAnexoComponent.vue';
import SeccionesComponent from '@/components/frontend/events/compra/components/secciones/SeccionesComponent';
import ButacasAnexoComponent from './ButacasAnexoComponent.vue';
import LeyendaColorEventos from './LeyendaColorEventos.vue';

export default {
    props: ['evento_id', 'sesion_id', 'zona'],
    data() {
        return {
            loading: true,
            zonas: [],
            select_region: true,
            select_butacas: false,
            zona_id: null,
            asientos: [],
            filas: null,
            concepto: '',
            bloqueando: false,
            n_butacas: 0,
            events: [],
            old_event: null,
            evento: null,
            plazasSeleccionadas: [],
            seleccionarTodas: false,
            recintoAnexoKey: 0, 
            plazas: null,
            contadorPlazas: null,
            recinto_id: null
        }
    },
    created() {
        this.getEvento();
        if(this.zona){
            this.irAZona(this.zona)
        }
    },
    computed: {
        bloquear_boton() {
            return !(this.asientos.length > 0 || this.plazasSeleccionadas.length > 0 || this.n_butacas > 0);
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        total_sesion() {
            var total = 0;

            if(this.zonas && this.zonas.length > 0) {
                for (var i = 0; i < this.zonas.length; i++) {
                    if(this.zonas[i].name != 'Internacional' && this.zonas[i].name != 'Baby' && this.zonas[i].name != 'internacional' && this.zonas[i].name != 'INTERNACIONAL') {
                        total = total + this.zonas[i].sesion;
                    }
                }
            }

            return total;
        },
        total_confirmados() {
            var total = 0;

            if(this.zonas && this.zonas.length > 0) {
                for (var i = 0; i < this.zonas.length; i++) {
                    if(this.zonas[i].name != 'Internacional' && this.zonas[i].name != 'Baby' && this.zonas[i].name != 'internacional' && this.zonas[i].name != 'INTERNACIONAL') {
                        total = (total + this.zonas[i].confirmados) - this.zonas[i].count_bloqueados;
                    }
                }
            }

            return total < 0 ? 0 : total;
        },
        total_libres() {
            var total = 0;

            if(this.zonas && this.zonas.length > 0) {
                for (var i = 0; i < this.zonas.length; i++) {
                    if(this.zonas[i].name != 'Internacional' && this.zonas[i].name != 'Baby' && this.zonas[i].name != 'internacional' && this.zonas[i].name != 'INTERNACIONAL') {
                        var libres = null;

                        if (this.zonas[i].plazas && this.zonas[i].plazas.length > 0) {
                            libres = this.zonas[i].libres;
                        } else {                            
                            libres = this.zonas[i].with_seats ? this.zonas[i].total_asientos : this.zonas[i].aforo;
                            libres = libres - this.zonas[i].confirmados - this.zonas[i].sesion;
                        }

                        total = total + libres;
                    }
                }
            }

            return total;
        },
        total_bloqueadas() {
            var total = 0;

            if(this.zonas && this.zonas.length > 0) {
                for (var i = 0; i < this.zonas.length; i++) {
                    if(this.zonas[i].name != 'Internacional' && this.zonas[i].name != 'Baby' && this.zonas[i].name != 'internacional' && this.zonas[i].name != 'INTERNACIONAL') {
                        total = total + this.zonas[i].count_bloqueados;
                    }
                }
            }

            return total;
        },
        total_aforo() {
            var total = 0;

            if(this.zonas && this.zonas.length > 0) {
                for (var i = 0; i < this.zonas.length; i++) {
                    if(this.zonas[i].name != 'Internacional' && this.zonas[i].name != 'Baby' && this.zonas[i].name != 'internacional' && this.zonas[i].name != 'INTERNACIONAL') {
                        var aforo = null;

                        if (this.zonas[i].plazas && this.zonas[i].plazas.length > 0) {
                            aforo = this.zonas[i].aforo;
                        } else {                            
                            aforo = this.zonas[i].with_seats ? this.zonas[i].total_asientos : this.zonas[i].aforo;
                        }

                        total = total + aforo;
                    }
                }
            }

            return total;
        },

        url_imprimir_plano_general() {
            return this.config.API_BASE + '/eventos/' + this.evento_id + '/sesiones/' + this.sesion_id + '/butacas/print/general?api_key=' + localStorage.getItem('token');
        }
    },
    watch: {
        old_event() {
            this.bloquearAsientosOldEvent();
        }
    },
    methods: {
        getPlazas(){
            this.loading = true;

            const params = {
                evento_id: this.evento_id,
                sesion_id: this.sesion_id,
                recinto_id: this.recinto_id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.plazas.taquilla'), params)
                .then(res => {
                    this.plazas = res.data.data;
                    this.total_plazas() 
                }).finally(() => {
                    this.loading = false
                });
                
        },
        getEvento() {
            this.loading = true;

            const data = {
                evento_id: this.evento_id,
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.show'), data).then(res => {
                this.evento = res.data.data;
                this.recinto_id = this.evento.place_id
                if(this.recinto_id){
                    this.getPlazas();
                    if (this.evento && this.evento.place_obj && this.evento.place_obj.tipo_svg === 1 && this.evento.place_obj.tipo_proceso_online === 1) {
                        this.getZonas();
                    }
                }
                
            }).finally(() => {
                this.loading = false
            });
        },
        getTitleAsiento(asiento, fila) {
            var concepto = null;

            if(asiento.info && asiento.info.concepto != null) {
                concepto = true;
            }

            if(asiento.ocupado == 3 || concepto) {
                return 'Concepto: ' + (asiento.info ? asiento.info.concepto : '');
            } else {
                var text = '';

                text = text + 'Fila: ' + fila + ' Butaca: ' + asiento.asiento;

                if(asiento.info) {
                    if(asiento.info.n_abonado) {
                        text = text + ' Nº Abonado: ' + asiento.info.n_abonado;
                    }

                    if(asiento.info.name) {
                        text = text + ' Nombre: ' + asiento.info.name;
                    }

                    if(asiento.info.surnames) {
                        text = text + ' ' + asiento.info.surnames;
                    }

                    if(asiento.info.telefono) {
                        text = text + ' Telefono: ' + asiento.info.telefono
                    }
                }
                return text;
            }
        },
        volver() {
            this.concepto = '';
            this.asientos = [];
            this.zona = null;
            this.select_region = true;
            this.select_butacas = false;

            this.getZonas();
        },
        getZonas() {
            this.loading = true;

            const params = {
                filters: {
                    evento_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id
                }
            };

            this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                this.zonas = res.data;
                this.getZonasAnexas();
            }).finally(() => this.loading = false);
            
        },
        getZonasAnexas() {
            this.loading = true;
            const params = {
                filters: {
                    evento_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id
                }
            };
            this.$store.dispatch(this.config.getVuexAlias('zonas.anexas.index'), params).then(res => {
                this.zonas = this.zonas.concat(res.data.data);

            }).finally(() => this.loading = false);
        },
        bloquearAsientos() {
            this.bloqueando = true;

            const params = {
                filters: {},
                asientos: this.asientos,
                concepto: this.concepto,
                evento_id: this.evento_id,
                sesion_id: this.sesion_id,
                zona_id: this.zona.id,
                n_butacas: this.n_butacas,
                plazasSeleccionadas: this.plazasSeleccionadas
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.bloquear.asientos'), params).then(res => {
                this.concepto = '';
                this.bloqueando = false;
                this.asientos = [];
                this.recintoAnexoKey += 1;
                this.getZona(this.zona.id);
                this.plazasSeleccionadas = [];
            });
        },
        bloquearAsientosGeneral() {
            this.bloqueando = true;

            const params = {
                filters: {},
                evento_id: this.evento_id,
                sesion_id: this.sesion_id,
                recinto_id: this.recinto_id,
                butacas: this.asientos,
                concepto: this.concepto,
            };
            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.bloquear.asientos.general'), params).then(res => {
                this.concepto = '';
                this.bloqueando = false;
                this.asientos = [];
                this.recintoAnexoKey += 1;
                this.getPlazas();
                this.plazasSeleccionadas = [];
            });
        },
        bloquearAsientosOldEvent(old_event) {
            this.loading = true;
            this.bloqueando = true;
            
            const params = {
                filters: {},
                evento_id: this.evento_id,
                sesion_id: this.sesion_id,
                old_event: old_event.id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.bloquear.asientos'), params).then(res => {
                if(res.data.error) {
                    this.$toast.error("Este evento tiene las butacas de los abonados Bloqueados");
                } else {
                    this.$toast.success("Butacas bloqueadas correctamente!");
                }      

                this.concepto = '';
                this.bloqueando = false;
                this.asientos = [];
                this.recintoAnexoKey += 1;
                this.getZona(this.zona.id);
                this.loading = false;
            }).catch(error => {
                this.$toast.error("Este evento tiene las butacas de los abonados Bloqueados");
                console.log(error);
            });
        },
        getZona(id) {
            this.loading = true;

            const params = {
                filters: {
                    zona_id: id,
                    conf: true,
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id
                },
            };

            this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                this.select_region = false;
                this.select_butacas = true;
                this.filas = res.data.configuracion_asientos;
                this.zona.count_bloqueados = res.data.count_bloqueados;
                this.zona.total_libres = res.data.total_libres;
                this.zona.tipo_svg = res.data.tipo_svg;
                this.getPlazasZona(id);
                this.loading = false;
            });
        },
        getPlazasZona(zona_id) {
            this.loading = true;                
            const params = {
                zona_id: zona_id,
                filters: {
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id
                }
            };
            this.$store.dispatch(this.config.getVuexAlias('zona.plazas'), params).then(res => {
                this.zona.plazas = res.data.data;
                this.loading = false;
            });
        },
        setAsientosBloqueados() {
            for (var i in this.filas) {
                for (var x = 0; x < this.filas[i].length; x++) {
                    if(this.filas[i][x].ocupado == 3) {
                        this.asientos.push({
                            seat: this.filas[i][x].asiento,
                            row: i,
                            region_id: this.zona.id
                        });
                    }
                }
            }
        },
        irAZona(zona) {
            this.getZona(zona.id);
            this.zona = zona;
        },
        selectZonaTable(paso, zona) {
            this.getZona(zona.id);
            this.zona = zona;
        },
        toggleSeleccion : function(fila, asiento) {
            //lo anado a asientos_seleccionados
            //si no he seleccionado ninguna butaca y ademas tengo un abonado
            for(var i in this.filas[fila]) {
                if(this.filas[fila][i].asiento == asiento && this.filas[fila][i].ocupado != 1) {
                    if(this.filas[fila][i].seleccionado) {
                        //si el asiento estaba seleccionado, lo quito de asientos
                        for(var j in this.asientos) {
                            if(this.asientos[j].row == fila && this.asientos[j].seat == asiento) {
                                this.asientos.splice(j, 1);
                            }
                        }
                    } else {
                        //si el asiento no estaba seleccionado es porque lo voy a anadir, asi que lo meto en asientos
                        const data = {
                            row : fila,
                            seat : this.filas[fila][i].asiento,
                            region_id : this.zona.id,
                            zona_nombre : this.zona.name,
                        }
                        this.asientos.push(data);
                    }
                    this.filas[fila][i].seleccionado = !this.filas[fila][i].seleccionado;
                }
            }
        },
        selectAll() {
            if(this.zona.with_seats) {
                if (this.zona.tiene_plazas) {
                    this.seleccionarTodas = true;
                    var plazas_formatted = this.zona.plazas.filter(plaza => plaza.esta_disponible == true || plaza.esta_disponible == false && plaza.esta_bloqueada == true );
                    plazas_formatted.forEach(plaza => {
                        this.clickZona(plaza);
                    });
                } else {
                    for(var fila in this.filas) {
                        for(var asiento in this.filas[fila]) {
                            if((this.filas[fila][asiento].ocupado == 0 || this.filas[fila][asiento].ocupado == 3) && !this.filas[fila][asiento].seleccionado) {
                                //si el asiento no estaba seleccionado es porque lo voy a anadir, asi que lo meto en asientos
                                const data = {
                                    row : fila,
                                    seat : this.filas[fila][asiento].asiento,
                                    region_id : this.zona.id,
                                    zona_nombre : this.zona.name,
                                }
                                this.asientos.push(data);
    
                                this.filas[fila][asiento].seleccionado = !this.filas[fila][asiento].seleccionado;
                            }
                        }
                    } 
                }
            } else {
                this.n_butacas = this.zona.aforo;
            }                
        },
        clearAll() {
            if(this.zona.with_seats) {
                this.asientos = [];
                for(var fila in this.filas) {
                    for(var asiento in this.filas[fila]) {
                        if(this.filas[fila][asiento].seleccionado) {
                            //si el asiento estaba seleccionado, lo quito de asientos

                            this.filas[fila][asiento].seleccionado = !this.filas[fila][asiento].seleccionado;
                        }
                    }
                } 
            } else {
                this.n_butacas = this.zona.aforo;
            }                
        },
        selectAllButacas() {
            this.seleccionarTodas = true;
            var plazas_formatted = this.plazas.filter(plaza => plaza.libre == true || plaza.libre == false && plaza.ocupada.bloqueada == true );
            plazas_formatted.forEach(plaza => {
                this.clickPlaza(plaza);
            });            
        },
        clearAllButacas() {
            this.asientos = [];
            for(var fila in this.filas) {
                for(var asiento in this.filas[fila]) {
                    if(this.filas[fila][asiento].seleccionado) {
                        //si el asiento estaba seleccionado, lo quito de asientos

                        this.filas[fila][asiento].seleccionado = !this.filas[fila][asiento].seleccionado;
                    }
                }
            }              
        },
        openModal() {
            this.$modal.show('cargarButacasEventoAnterior');
        },
        closeModal() {
            this.$modal.hide('cargarButacasEventoAnterior');
        },
        clickZona(plazaSeleccionada) {
            const plazaEncontrada = this.zona.plazas.find(plaza => plaza.id === plazaSeleccionada.id);
            if (plazaEncontrada) {
                if (this.zona.tipo_svg === "1") {
                    const popoverElement = document.getElementById('popover-' + plazaEncontrada.id);

                    if (popoverElement.classList.contains('plaza_bloqueada')) {
                        popoverElement.classList.remove('plaza_bloqueada');
                        popoverElement.classList.add('seleccionada');
                        this.addToPlazasSeleccionadas(plazaSeleccionada);
                    } else {
                        plazaEncontrada.seleccionada = !plazaEncontrada.seleccionada;
                        this.updatePlazasSeleccionadas(plazaSeleccionada, plazaEncontrada.seleccionada);
                    }
                }
                if (this.zona.tipo_svg === "2") {
                    plazaEncontrada.seleccionada = !plazaEncontrada.seleccionada;
                    this.updatePlazasSeleccionadas(plazaSeleccionada, plazaEncontrada.seleccionada);
                }
            }
        },

        addToPlazasSeleccionadas(plazaSeleccionada) {
            if (!this.plazasSeleccionadas.some(plaza => plaza.id === plazaSeleccionada.id)) {
                this.plazasSeleccionadas.push(plazaSeleccionada);
            }
        },

        updatePlazasSeleccionadas(plazaSeleccionada, isSelected) {
            if (isSelected) {
                this.addToPlazasSeleccionadas(plazaSeleccionada);
            } else {
                const index = this.plazasSeleccionadas.findIndex(plaza => plaza.id === plazaSeleccionada.id);
                if (index !== -1) {
                    this.plazasSeleccionadas.splice(index, 1);
                }
            }
        },
        clickPlaza(plazaSeleccionada) {
            const plazaEncontrada = this.plazas.find(plaza => plaza.id === plazaSeleccionada.id);

            if (plazaEncontrada) {
                plazaEncontrada.seleccionada = !plazaEncontrada.seleccionada; 

                if (plazaEncontrada.seleccionada) {
                    if (!this.plazasSeleccionadas.some(plaza => plaza.id === plazaSeleccionada.id)) {
                        this.plazasSeleccionadas.push(plazaSeleccionada);
                        this.asientos.push(plazaSeleccionada.id);
                    }
                } else {
                    const index = this.plazasSeleccionadas.findIndex(plaza => plaza.id === plazaSeleccionada.id);
                    if (index !== -1) {
                        this.plazasSeleccionadas.splice(index, 1);
                        this.asientos.splice(index, 1);
                    }
                }
            }
        },
        total_plazas() {
            this.loading = true;

            this.contadorPlazas = {
                bloqueado: 0,
                aforo: 0,
                libres: 0
            };

            for (let plaza of this.plazas) {
                if (plaza.ocupada && plaza.ocupada.bloqueada) {
                    this.contadorPlazas.bloqueado++;
                }
                if (plaza.libre) {
                    this.contadorPlazas.libres++;
                }
            }

            this.contadorPlazas.aforo = this.plazas.length;
        },
    },
    components: {
        LoaderComponent, SvgComponent, AsientoComponent, TerrenoJuegoComponent, MainContent, TablaSectoresComponent, CargarButacasEventoAnterior, RecintoAnexoComponent, SeccionesComponent, ButacasAnexoComponent, LeyendaColorEventos
    }
}
</script>

<style>
.color-text-wrapper {
    display: flex;
    align-items: center;
}
</style>